import React, { useEffect, useState } from "react";
import CardHeader from "../../../components/atoms/cardHeader";
import { Row, Col } from "antd";
import { useDispatch } from "react-redux";
import { UploadBloodSampleReportThunk } from "../../../store/thunks/orderThunk";
import BottomRightButton from "../../../components/atoms/formFields/buttons/bottomRightButton";
import { Link } from "react-router-dom";

const BloodSampleReport = ({ overview }) => {
  const dispatch = useDispatch();

  const BloodSampleProducts =
    overview?.orderItem?.filter(
      (item) =>
        item.productDomainCategory?.en === "Blood & Sample Diagnostics" &&
        item.orderStage === "DELIVERED",
    ) || [];

  const [formState, setFormState] = useState({});

  const [error, setError] = useState({});

  useEffect(() => {
    const data = {};

    BloodSampleProducts.forEach((item) => {
      data[item.itemId] = {
        itemId: item.itemId,
        report: null,
        reportPreview: item?.reportUrl || null,
        sampleReportRemarks: "Test",
      };
    });

    setFormState(data);
  }, [overview]);

  const handleSave = (e, itemId) => {
    e.preventDefault();

    if (formState?.[itemId]?.report) {
      setError((prev) => ({
        ...prev,
        [itemId]: {},
      }));

      dispatch(
        UploadBloodSampleReportThunk({
          reportUploadRequest: {
            itemId: formState?.[itemId]?.itemId,
            report: formState?.[itemId]?.report,
            sampleReportRemarks: formState?.[itemId]?.sampleReportRemarks,
          },
        }),
      );
    } else {
      setError((prev) => ({
        ...prev,
        [itemId]: {
          report: "Please select a file to upload.",
        },
      }));
    }
  };

  if (!BloodSampleProducts?.length) {
    return (
      <div className="align-items-center d-flex font-weight-bolder h-200px justify-content-center">
        No Blood Sample Report available.
      </div>
    );
  }

  const isImageFile = (file) => {
    return file?.type?.startsWith("image/");
  };

  const isPdfFile = (url) => {
    return url?.toLowerCase()?.endsWith(".pdf");
  };


  return (
    <>
      <div className="card card-custom mb-5">
        <CardHeader name={"Blood Sample Report"} />

        {BloodSampleProducts?.map((item) => (
          <div className="border border-1 rounded border-light-darkcard-body mt-3 p-4">
            <Row gutter={[30, 30]} key={item?.itemId}>
              <Col sm={7}>
                <div className="d-flex align-items-center">
                  <img
                    src={item?.productImageURL}
                    alt={item?.productName?.en}
                    className="img-fluid"
                    style={{
                      width: "100px",
                      height: "100px",
                      objectFit: "contain",
                    }}
                  />

                  <div className="ml-3">
                    <div className="font-weight-bolder font-size-lg">
                      {item?.productName?.en}
                    </div>

                    <small className="text-muted">
                      Item ID: {item?.itemId}
                    </small>
                  </div>
                </div>
              </Col>

              <Col sm={8}>
                <label className="font-weight-bolder font-size-lg">
                  Upload Blood Sample Report
                  <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  className={
                    error?.[item?.itemId]?.report
                      ? "invalid form-control h-auto"
                      : "form-control h-auto"
                  }
                  type="file"
                  required={true}
                  accept=".pdf"
                  onChange={(e) => {
                    const file = e.target.files?.[0];

                    setFormState({
                      ...formState,
                      [item?.itemId]: {
                        ...formState?.[item?.itemId],
                        report: file,
                        reportPreview: file ? URL.createObjectURL(file) : null,
                      },
                    });

                    setError({
                      ...error,
                      [item?.itemId]: {
                        report: file ? null : "Please select a file to upload.",
                      },
                    });
                  }}
                />
                <small className="font-size-xs text-warning"> please upload pdf only</small>

                <small className="text-danger text-capitalize">
                  {error?.[item?.itemId]?.report}
                </small>
              </Col>

              <Col sm={5}>
                <div className="bloodimgPreview m-0 ml-auto">
                  <Link
                    to={
                      formState?.[item?.itemId]?.reportPreview ||
                      item?.reportUrl
                    }
                    className="document_file"
                    target="_blank"
                    rel="noopener noreferrer"
                  >

                    {formState?.[item?.itemId]?.report ? (
                      // Newly selected file
                      isImageFile(formState?.[item?.itemId]?.report) ? (
                        <img
                          alt="Report preview"
                          src={formState?.[item?.itemId]?.reportPreview}
                          className="w-100"
                        />
                      ) : (


                        <div className="d-flex flex-column align-items-center justify-content-center p-4">
                          <i className="fas fa-file-pdf text-danger font-size-h1" />
                          <span className="mt-2 font-weight-bolder">
                            {formState?.[item?.itemId]?.report?.name}
                          </span>
                        </div>
                      )
                    ) : (
                      // Existing report from API
                      isPdfFile(item?.reportUrl) ? (
                        <div className="d-flex flex-column align-items-center justify-content-center p-4">
                          <i className="fas fa-file-pdf text-danger font-size-h1" />
                          <span className="mt-2 font-weight-bolder">
                            View PDF Report
                          </span>
                        </div>


                      ) : (
                        <img
                          alt="Report img"
                          src={item?.reportUrl}
                          className="w-100"
                        />
                      )
                    )}</Link>

                </div>
              </Col>

              <Col sm={4}>
                <BottomRightButton
                  className=" mr-4"
                  name={"Upload"}
                  onClick={(e) => {
                    handleSave(e, item?.itemId);
                  }}
                />
              </Col>
            </Row>
          </div>
        ))}
      </div>
    </>
  );
};

export default BloodSampleReport;
